<div class="gtm-diagnostic-modal">
  <mat-dialog-content>
    <mat-tab-group>
      <!-- GTM Diagnostics Tab -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon>analytics</mat-icon>
          GTM Diagnóstico
        </ng-template>

        <div class="tab-content" *ngIf="diagnosticInfo">
          <!-- Environment Information Card -->
          <mat-card class="info-card">
            <mat-card-header>
              <mat-card-title>
                <mat-icon>info</mat-icon>
                Environment Information
              </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div class="info-row">
                <div class="info-label">
                  <mat-icon>settings</mat-icon>
                  <span>Environment</span>
                </div>
                <div class="info-value">
                  <span class="value-text">{{ diagnosticInfo.environment }}</span>
                </div>
              </div>
              <div class="info-row">
                <div class="info-label">
                  <mat-icon>tag</mat-icon>
                  <span>GTM ID</span>
                </div>
                <div class="info-value">
                  <span class="value-text">{{ diagnosticInfo.gtmId }}</span>
                </div>
              </div>
              <div class="info-row">
                <div class="info-label">
                  <mat-icon>link</mat-icon>
                  <span>URL</span>
                </div>
                <div class="info-value">
                  <span class="value-text url-text">{{ diagnosticInfo.url }}</span>
                </div>
              </div>
            </mat-card-content>
          </mat-card>

          <!-- GTM Status Card -->
          <mat-card class="status-card">
            <mat-card-header>
              <mat-card-title>
                <mat-icon>health_and_safety</mat-icon>
                GTM Status
              </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div class="info-row">
                <div class="info-label">
                  <mat-icon [color]="diagnosticInfo.isInitialized ? 'primary' : 'warn'">
                    {{ diagnosticInfo.isInitialized ? 'check_circle' : 'error' }}
                  </mat-icon>
                  <span>GTM Initialized</span>
                </div>
                <div class="info-value">
                  <mat-chip-list>
                    <mat-chip [class]="getChipClass(diagnosticInfo.isInitialized)">
                      {{ diagnosticInfo.isInitialized ? 'Active' : 'Inactive' }}
                    </mat-chip>
                  </mat-chip-list>
                </div>
              </div>
              <div class="info-row">
                <div class="info-label">
                  <mat-icon [color]="diagnosticInfo.gtmScriptExists ? 'primary' : 'warn'">
                    {{ diagnosticInfo.gtmScriptExists ? 'check_circle' : 'error' }}
                  </mat-icon>
                  <span>GTM Script Loaded</span>
                </div>
                <div class="info-value">
                  <mat-chip-list>
                    <mat-chip [class]="getChipClass(diagnosticInfo.gtmScriptExists)">
                      {{ diagnosticInfo.gtmScriptExists ? 'Loaded' : 'Not Loaded' }}
                    </mat-chip>
                  </mat-chip-list>
                </div>
              </div>
              <div class="info-row">
                <div class="info-label">
                  <mat-icon [color]="diagnosticInfo.dataLayerExists ? 'primary' : 'warn'">
                    {{ diagnosticInfo.dataLayerExists ? 'check_circle' : 'error' }}
                  </mat-icon>
                  <span>DataLayer Exists</span>
                </div>
                <div class="info-value">
                  <mat-chip-list>
                    <mat-chip [class]="getChipClass(diagnosticInfo.dataLayerExists)">
                      {{ diagnosticInfo.dataLayerExists ? 'Available' : 'Not Available' }}
                    </mat-chip>
                  </mat-chip-list>
                </div>
              </div>
              <div class="info-row">
                <div class="info-label">
                  <mat-icon [color]="diagnosticInfo.gtagFunctionExists ? 'primary' : 'warn'">
                    {{ diagnosticInfo.gtagFunctionExists ? 'check_circle' : 'error' }}
                  </mat-icon>
                  <span>Gtag Function Available</span>
                </div>
                <div class="info-value">
                  <mat-chip-list>
                    <mat-chip [class]="getChipClass(diagnosticInfo.gtagFunctionExists)">
                      {{ diagnosticInfo.gtagFunctionExists ? 'Available' : 'Not Available' }}
                    </mat-chip>
                  </mat-chip-list>
                </div>
              </div>
            </mat-card-content>
          </mat-card>

          <!-- DataLayer Information Card -->
          <mat-card class="data-card">
            <mat-card-header>
              <mat-card-title>
                <mat-icon>data_object</mat-icon>
                DataLayer Information
              </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div class="info-row">
                <div class="info-label">
                  <mat-icon>numbers</mat-icon>
                  <span>DataLayer Length</span>
                </div>
                <div class="info-value">
                  <span class="value-text">{{ diagnosticInfo.dataLayerLength }}</span>
                </div>
              </div>
              <div class="info-row">
                <div class="info-label">
                  <mat-icon>event</mat-icon>
                  <span>Last Event Type</span>
                </div>
                <div class="info-value">
                  <span class="value-text">{{ diagnosticInfo.lastEventType || 'None' }}</span>
                </div>
              </div>
            </mat-card-content>
          </mat-card>

          <!-- Actions Card -->
          <mat-card class="actions-card">
            <mat-card-content>
              <div class="action-buttons">
                <button mat-raised-button color="primary" (click)="runGtmDiagnostics()">
                  <mat-icon>refresh</mat-icon>
                  Refresh Diagnostics
                </button>
                <button mat-raised-button color="accent" (click)="sendTestEvent()">
                  <mat-icon>science</mat-icon>
                  Send Test Event
                </button>
                <button mat-stroked-button (click)="copyGtmToClipboard()">
                  <mat-icon>content_copy</mat-icon>
                  Copy to Clipboard
                </button>
              </div>
            </mat-card-content>
          </mat-card>
        </div>

        <mat-card class="no-data-card" *ngIf="!diagnosticInfo">
          <mat-card-content>
            <div class="no-data-content">
              <mat-icon>info</mat-icon>
              <p>No diagnostic data available</p>
            </div>
          </mat-card-content>
        </mat-card>
      </mat-tab>

      <!-- Current Navigation Tab -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon>navigation</mat-icon>
          Current Navigation
        </ng-template>

        <div class="tab-content">
          <mat-card class="navigation-card">
            <mat-card-header>
              <mat-card-title>
                <mat-icon>route</mat-icon>
                Navigation Information
              </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div class="info-row">
                <div class="info-label">
                  <mat-icon>place</mat-icon>
                  <span>Current Route</span>
                </div>
                <div class="info-value">
                  <span class="value-text route-path">{{ navigationStats.current_route || 'N/A' }}</span>
                </div>
              </div>
              <div class="info-row">
                <div class="info-label">
                  <mat-icon>history</mat-icon>
                  <span>Previous Route</span>
                </div>
                <div class="info-value">
                  <span class="value-text route-path">{{ navigationStats.previous_route || 'N/A' }}</span>
                </div>
              </div>
              <div class="info-row">
                <div class="info-label">
                  <mat-icon>schedule</mat-icon>
                  <span>Last Update</span>
                </div>
                <div class="info-value">
                  <span class="value-text timestamp">{{ navigationStats.timestamp || 'N/A' }}</span>
                </div>
              </div>
            </mat-card-content>
          </mat-card>

          <mat-card class="actions-card">
            <mat-card-content>
              <div class="action-buttons">
                <button mat-raised-button color="primary" (click)="sendTestRouteEvent()">
                  <mat-icon>science</mat-icon>
                  Test Route Event
                </button>
                <button mat-stroked-button (click)="exportRouteData()">
                  <mat-icon>download</mat-icon>
                  Export Data
                </button>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-tab>

      <!-- Route Statistics Tab -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon>analytics</mat-icon>
          Route Statistics
        </ng-template>

        <div class="tab-content">
          <mat-card class="statistics-card">
            <mat-card-header>
              <mat-card-title>
                <mat-icon>bar_chart</mat-icon>
                Route Activity Statistics
              </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div class="info-row">
                <div class="info-label">
                  <mat-icon [color]="hasRouteActivity ? 'primary' : 'warn'">
                    {{ hasRouteActivity ? 'check_circle' : 'error' }}
                  </mat-icon>
                  <span>Route Activity Status</span>
                </div>
                <div class="info-value">
                  <mat-chip-list>
                    <mat-chip [class]="getChipClass(hasRouteActivity)">
                      {{ hasRouteActivity ? 'Active' : 'No Activity' }}
                    </mat-chip>
                  </mat-chip-list>
                </div>
              </div>
              <div class="info-row">
                <div class="info-label">
                  <mat-icon>trending_up</mat-icon>
                  <span>Total Navigations</span>
                </div>
                <div class="info-value">
                  <span class="value-text">{{ navigationStats.total_navigations || 0 }}</span>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button color="primary" (click)="refreshAll()">
      <mat-icon>refresh</mat-icon>
      Refresh All
    </button>
    <button mat-button mat-dialog-close>Close</button>
  </mat-dialog-actions>

  <!-- Production Mode Warning -->
  <mat-card class="production-warning" *ngIf="isProductionMode">
    <mat-card-content>
      <div class="warning-content">
        <mat-icon color="warn">warning</mat-icon>
        <span>GTM Diagnostic tools are disabled in production mode</span>
      </div>
    </mat-card-content>
  </mat-card>
</div>
